import * as MilesHistory from './components/MilesHistory.css';
export default {
    MilesHistory
};
